"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = __importDefault(require("assert"));
function default_1(offset, current, length, origin) {
    if (origin === void 0) { origin = true; }
    if (typeof origin === 'boolean') {
        if (!origin) {
            offset += current;
        }
    }
    else {
        if (origin === 'current') {
            offset += current;
        }
        else if (origin === 'end') {
            offset = length - offset;
        }
    }
    assert_1.default(offset >= 0 && offset <= length, 'Offset out of range.');
    return offset;
}
exports.default = default_1;
